import '../styles/pages/products.scss'
import ReactGA from 'react-ga4'
import Title from '../components/ui/Title'

const Products = () => (
    <div className='page-container'>
        <Title text='Products' size='full' />
        {/*
                <div className="line-container">
                    <div className="le-container" id="LE">
                        <div className="art-wrapper" style={{width: '100%'}}>
                            <img src="./img/products/le-ps4.webp" alt="the legend of heroes trails from zero limited edition ps4" />
                        </div>
                        <div className="link-list">
                            <a href="https://store.nisamerica.com/the-legend-of-heroes-trails-from-zero-limited-edition-ps4" target="_blank" rel="noreferrer">
                                <button className="ps-button" onClick={
                                    ()=>{
                                        ReactGA.event({
                                        category: 'Product Link',
                                        action: 'Click',
                                        label: `PS4 - Limited Edition`
                                    })}
                                }>
                                    NISA Online Store
                                </button>
                            </a>
                        </div>
                    </div>
                    <div className="le-container reverse" id="LE">
                        <div className="art-wrapper" style={{width: '100%'}}>
                        <img src="./img/products/le-nsw.webp" alt="the legend of heroes trails from zero limited edition nsw" />
                        </div>
                        <div className="link-list">
                            <a href="https://store.nisamerica.com/the-legend-of-heroes-trails-from-zero-limited-edition-nintendo-switch" target="_blank" rel="noreferrer">
                                <button className="nsw-button" onClick={
                                    ()=>{
                                        ReactGA.event({
                                        category: 'Product Link',
                                        action: 'Click',
                                        label: `NSW - Limited Ediiton`
                                    })}
                                }>
                                    NISA Online Store
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            */}
        <div className='captcha-container'>
            <h1 className='products-title'>PlayStation®4 Deluxe Edition</h1>
            <h2 className=''>Available Now</h2>
        </div>
        <div className='le-container'>
            <div className='art-wrapper pack'>
                <img
                    src='./img/products/ps4.webp'
                    alt='PS4 Legend of Heroes Trails from Zero Packshot'
                    className='art'
                />
            </div>
            <div className='link-list'>
                <a
                    href='https://www.amazon.com/Legend-Heroes-Trails-Zero-PlayStation-4/dp/B099TL6FN5'
                    target='_blank'
                    rel='noreferrer'
                >
                    <button
                        className='ps-button'
                        onClick={() => {
                            ReactGA.event({
                                category: 'Product Link',
                                action: 'Click',
                                label: `PS4 - Amazon`,
                            })
                        }}
                    >
                        Amazon
                    </button>
                </a>
                <a
                    href='https://www.amazon.ca/Legend-Heroes-Trails-Zero-PlayStation/dp/B099TL6FN5'
                    target='_blank'
                    rel='noreferrer'
                >
                    <button
                        className='ps-button'
                        onClick={() => {
                            ReactGA.event({
                                category: 'Product Link',
                                action: 'Click',
                                label: `PS4 -  Amazon (CA)`,
                            })
                        }}
                    >
                        Amazon (CA)
                    </button>
                </a>
                <a
                    href='https://www.gamestop.com/video-games/products/the-legend-of-heroes-trails-from-zero/11176889.html'
                    target='_blank'
                    rel='noreferrer'
                >
                    <button
                        className='ps-button'
                        onClick={() => {
                            ReactGA.event({
                                category: 'Product Link',
                                action: 'Click',
                                label: `PS4 - GameStop`,
                            })
                        }}
                    >
                        GameStop
                    </button>
                </a>
              
                <a
                    href='https://www.bestbuy.com/site/the-legend-of-heroes-trails-from-zero-playstation-4/6481219.p?skuId=6481219'
                    target='_blank'
                    rel='noreferrer'
                >
                    <button
                        className='ps-button'
                        onClick={() => {
                            ReactGA.event({
                                category: 'Product Link',
                                action: 'Click',
                                label: `PS4 - BestBuy`,
                            })
                        }}
                    >
                        BestBuy
                    </button>
                </a>
            </div>
        </div>{' '}
        <div className='captcha-container'>
            <h1 className='products-title'>Nintendo Switch™ Deluxe Edition</h1>
            <h2 className=''>Available Now</h2>
        </div>
        <div className='le-container '>
            <div className='art-wrapper pack'>
                <img
                    src='./img/products/nsw.webp'
                    alt='NSW Legend of Heroes Trails from Zero Packshot'
                    className='art'
                />
            </div>
            <div className='link-list'>
                <a
                    href='https://www.amazon.com/Legend-Heroes-Trails-Zero-Nintendo-Switch/dp/B099TL61TZ/'
                    target='_blank'
                    rel='noreferrer'
                >
                    <button
                        className='nsw-button'
                        onClick={() => {
                            ReactGA.event({
                                category: 'Product Link',
                                action: 'Click',
                                label: `NSW - Amazon`,
                            })
                        }}
                    >
                        Amazon
                    </button>
                </a>
                <a
                    href='https://www.amazon.ca/Legend-Heroes-Trails-Nintendo-Switch/dp/B099TL61TZ/'
                    target='_blank'
                    rel='noreferrer'
                >
                    <button
                        className='nsw-button'
                        onClick={() => {
                            ReactGA.event({
                                category: 'Product Link',
                                action: 'Click',
                                label: `NSW - Amazon (CA)`,
                            })
                        }}
                    >
                        Amazon (CA)
                    </button>
                </a>
                
              
                <a
                    href='https://www.bestbuy.com/site/the-legend-of-heroes-trails-from-zero-nintendo-switch/6481218.p?skuId=6481218'
                    target='_blank'
                    rel='noreferrer'
                >
                    <button
                        className='nsw-button'
                        onClick={() => {
                            ReactGA.event({
                                category: 'Product Link',
                                action: 'Click',
                                label: `NSW - BestBuy`,
                            })
                        }}
                    >
                        BestBuy
                    </button>
                </a>
            </div>
        </div>
        <div className='captcha-container'>
            <div className='captcha-container'>
                <h1 className='products-title'>PC Versions</h1>
                <h2 className=''>Available Now</h2>
            </div>
        </div>
       
        <iframe
            src='https://store.steampowered.com/widget/1668510/'
            frameborder='0'
            width='646'
            height='190'
            title='Steam Widget'
            style={{ paddingTop: '50px' }}
        ></iframe>
        <div className='link-list'>
            <a
                href='https://store.epicgames.com/en-US/p/the-legend-of-heroes-trails-from-zero'
                target='_blank'
                rel='noreferrer'
            >
                <button
                    className='merch-button'
                    onClick={() => {
                        ReactGA.event({
                            category: 'Product Link',
                            action: 'Click',
                            label: `PC - Epic Games Store`,
                        })
                    }}
                >
                    Epic Games Store
                </button>
            </a>
            <a
                href='https://www.gog.com/en/game/the_legend_of_heroes_trails_from_zero_bundle'
                target='_blank'
                rel='noreferrer'
            >
                <button
                    className='merch-button'
                    onClick={() => {
                        ReactGA.event({
                            category: 'Product Link',
                            action: 'Click',
                            label: `PC - GOG`,
                        })
                    }}
                >
                    GOG
                </button>
            </a>
        </div>
    </div>
)

export default Products
